module.exports = __webpack_public_path__ + "static/media/icon-pin.923c7259.svg";